var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"login-logo-section"},[_c('div',{staticClass:"m-auto text-center",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"hero-img mb-5",attrs:{"src":"/images/Cockfight.png"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }